export const status = [{ value: 'ACTIVE' }, { value: 'INACTIVE' }];

export const category = [
  { value: 'associated', label: 'Mix Component/Charge', desc: 'Ordered quantity on every load' },
  { value: 'other', label: 'Other/Extra Product', desc: 'Deliver up to the ordered quantity' },
];
